import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f045b08e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "van-hairline--bottom"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "物流单号", -1))
const _hoisted_4 = { class: "shipment-num" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy",
  id: "shipmentNumCopyItem"
}, "复制", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title red-star" }, "收件信息", -1))
const _hoisted_7 = { class: "name-box" }
const _hoisted_8 = { class: "phone" }
const _hoisted_9 = { class: "address" }

import { useClipboard } from '@/compositions/common'
import { withDefaults, computed, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'receipt-info',
  props: {
    name: null,
    phone: null,
    address: null,
    shipmentNum: null,
    isShowShipmentNum: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { name: string, phone: string, address: string, shipmentNum: string, isShowShipmentNum: boolean };


const propsComputed = computed(() => props)

const { initClipboard } = useClipboard({
  text: () => propsComputed.value.shipmentNum,
})

onMounted(() => {
  initClipboard('#shipmentNumCopyItem')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(propsComputed).isShowShipmentNum)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(_unref(propsComputed).shipmentNum), 1),
            _hoisted_5
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({ 'receipt-info': _unref(propsComputed).isShowShipmentNum })
    }, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString(_unref(propsComputed).name), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(propsComputed).phone), 1)
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(propsComputed).address), 1)
    ], 2)
  ]))
}
}

})